/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { Linkspace_RunCommandInputLinkspace } from '../models/Linkspace_RunCommandInputLinkspace';
import type { CancelablePromise } from '../core/CancelablePromise';
import type { BaseHttpRequest } from '../core/BaseHttpRequest';
export class LinkspaceService {
    constructor(public readonly httpRequest: BaseHttpRequest) {}
    /**
     * Run linkspace migration command to es
     * Executes a console command asynchronously.
     * @param requestBody The new Linkspace resource
     * @returns void
     * @throws ApiError
     */
    public apiLinkspacerunCommandEsMigrationPost(
        requestBody: Linkspace_RunCommandInputLinkspace,
    ): CancelablePromise<void> {
        return this.httpRequest.request({
            method: 'POST',
            url: '/api/linkspace/run-command-es-migration',
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                400: `Invalid input`,
                403: `Forbidden`,
                422: `Unprocessable entity`,
            },
        });
    }
}
